

export const SCHOOL_COURSE_TYPE_HS = "Corso HS";
export const SCHOOL_COURSE_TYPE_LT = "LT";
export const SCHOOL_COURSE_TYPE_LM = "LM";
export const SCHOOL_COURSE_TYPE_LMCU = "LMCU";
// export const SCHOOL_COURSE_TYPE_MASTER_I_LIVELLO = "Master_I"
export const SCHOOL_COURSE_TYPE_MASTER_I_LIVELLO = "Master-I-Livello"
// export const SCHOOL_COURSE_TYPE_MASTER_II_LIVELLO = "Master_II"
export const SCHOOL_COURSE_TYPE_MASTER_II_LIVELLO = "Master-II-Livello"
export const SCHOOL_COURSE_TYPE_PHD = "PhD"
export const SCHOOL_COURSE_TYPE_BACHELOR = "Laurea Estero"
export const SCHOOL_COURSE_TYPE_MASTER_ESTERO = "Master Estero"
export const SCHOOL_COURSE_TYPE_LMCUE = "LMCUE"
export const SCHOOL_COURSE_TYPE_CORSO_SSML = "Corso SSML"
// export const SCHOOL_COURSE_TYPE_CORSO_AFAM = "AFAM"
export const SCHOOL_COURSE_TYPE_CORSO_AFAM = "Corso AFAM"
// export const SCHOOL_COURSE_TYPE_CORSO_ITS = "ITS"
export const SCHOOL_COURSE_TYPE_CORSO_ITS = "Corso ITS"
export const SCHOOL_COURSE_TYPE_CORSO_VOCATIONAL = "Corso Vocational"


export type DegreeType =
    | typeof SCHOOL_COURSE_TYPE_HS
    | typeof SCHOOL_COURSE_TYPE_LT
    | typeof SCHOOL_COURSE_TYPE_LM
    | typeof SCHOOL_COURSE_TYPE_LMCU
    | typeof SCHOOL_COURSE_TYPE_MASTER_I_LIVELLO
    | typeof SCHOOL_COURSE_TYPE_MASTER_II_LIVELLO
    | typeof SCHOOL_COURSE_TYPE_PHD
    | typeof SCHOOL_COURSE_TYPE_BACHELOR
    | typeof SCHOOL_COURSE_TYPE_MASTER_ESTERO
    | typeof SCHOOL_COURSE_TYPE_LMCUE
    | typeof SCHOOL_COURSE_TYPE_CORSO_SSML
    | typeof SCHOOL_COURSE_TYPE_CORSO_AFAM
    | typeof SCHOOL_COURSE_TYPE_CORSO_ITS
    | typeof SCHOOL_COURSE_TYPE_CORSO_VOCATIONAL;

export const degreeTypeLabels = {
    [SCHOOL_COURSE_TYPE_HS]: 'Diploma Scuola Superiore',
    [SCHOOL_COURSE_TYPE_LT]: 'Laurea Triennale',
    [SCHOOL_COURSE_TYPE_LM]: 'Laurea Magistrale',
    [SCHOOL_COURSE_TYPE_LMCU]: 'Laurea Magistrale a Ciclo Unico',
    [SCHOOL_COURSE_TYPE_MASTER_I_LIVELLO]: 'Master I Livello',
    [SCHOOL_COURSE_TYPE_MASTER_II_LIVELLO]: 'Master II Livello',
    [SCHOOL_COURSE_TYPE_PHD]: 'PhD',
    [SCHOOL_COURSE_TYPE_BACHELOR]: 'Laurea Estero',
    [SCHOOL_COURSE_TYPE_MASTER_ESTERO]: 'Master Estero',
    [SCHOOL_COURSE_TYPE_LMCUE]: 'LMCUE',
    [SCHOOL_COURSE_TYPE_CORSO_SSML]: 'Corso SSML',
    [SCHOOL_COURSE_TYPE_CORSO_AFAM]: 'Corso AFAM',
    [SCHOOL_COURSE_TYPE_CORSO_ITS]: 'Corso ITS',
    [SCHOOL_COURSE_TYPE_CORSO_VOCATIONAL]: 'Corso Vocational',
};

export const degreeTypeOrder = {
    [SCHOOL_COURSE_TYPE_HS]: 0,
    [SCHOOL_COURSE_TYPE_LT]: 1,
    [SCHOOL_COURSE_TYPE_LM]: 2,
    [SCHOOL_COURSE_TYPE_LMCU]: 3,
    [SCHOOL_COURSE_TYPE_MASTER_I_LIVELLO]: 4,
    [SCHOOL_COURSE_TYPE_MASTER_II_LIVELLO]: 5,
    [SCHOOL_COURSE_TYPE_PHD]: 6,
    [SCHOOL_COURSE_TYPE_BACHELOR]: 7,
    [SCHOOL_COURSE_TYPE_MASTER_ESTERO]: 8,
    [SCHOOL_COURSE_TYPE_LMCUE]: 9,
    [SCHOOL_COURSE_TYPE_CORSO_SSML]: 10,
    [SCHOOL_COURSE_TYPE_CORSO_AFAM]: 11,
    [SCHOOL_COURSE_TYPE_CORSO_ITS]: 12,
    [SCHOOL_COURSE_TYPE_CORSO_VOCATIONAL]: 13
};


export interface FetchSchoolCourseTypesParam {
    page: number,
    per_page: number,
    query_search: string,
    typeOption?: DegreeType[],
}

export interface SchoolCourseTypeResource {
    id: string
    name: string
}

export interface SchoolCourseTypesResource {
    school_course_types: SchoolCourseTypeResource[];
    page: number;
    total_count: number;
}

